// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1DFRA","subheader":"ReorderModal_subheader__1HSUM","listWrap":"ReorderModal_listWrap__2Bcz4"};